import { withProfiling } from '../self-measurements';
var scheduleOnPaint = withProfiling(function scheduleOnPaint(_callback) {
  var _globalThis$document;
  var callback = withProfiling(_callback);
  if (((_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.visibilityState) !== 'visible') {
    // last resort fallback
    setTimeout(callback, 100);
    return;
  }

  // Check if the Scheduler API is available
  if (typeof window.scheduler !== 'undefined' && typeof window.scheduler.postTask === 'function') {
    // Use scheduler.postTask if available
    // https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
    // Make sure we are scheduling this task before the browser paint the next frame
    requestAnimationFrame(function () {
      window.scheduler.postTask(callback, {
        priority: 'user-visible'
      });
    });
  }
  // if active tab, and can do requestAnimationFrame
  else if (typeof requestAnimationFrame !== 'undefined') {
    // Fallback to using double requestAnimationFrame
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        callback();
      });
    });
  }
});
export default scheduleOnPaint;